import { FormControl, InputLabel, MenuItem } from '@mui/material';
import React from 'react';
import { WO2Select } from 'src/common';
import { YearType } from '../store/types';

interface Props {
  value: YearType;
  setValue?: (value: YearType) => void;
}

export const YearTypeSelector = ({ setValue, value }: Props) => {
  return (
    <FormControl fullWidth disabled={!setValue}>
      <InputLabel id="year-type">Year Type</InputLabel>
      <WO2Select
        labelId="year-type"
        label="Year Type"
        onChange={(e) => {
          if (setValue) {
            setValue(e.target.value as YearType);
          }
        }}
        value={value}
      >
        <MenuItem value={YearType.FinancialYear}>Financial Year</MenuItem>
        <MenuItem value={YearType.CalendarYear}>Calendar Year</MenuItem>
      </WO2Select>
    </FormControl>
  );
};
